import TeacherItem from './TeacherItem';

export default TeacherItem;
